export const GLASS_INPUT_STYLE: React.CSSProperties = {
  background: "rgba(255, 255, 255, 0.1)",
  boxShadow:
    "1px 1px 4px 0px rgba(255, 255, 255, 0.24) inset, -1px -1px 4px 0px rgba(255, 255, 255, 0.24) inset",
};

/** *****************************************
 * Global Search Suggestions Res Type
 ***************************************** */
type HistoryItem = {
  id: number;
  keyword: string;
  searchDt: string;
}

type RecentSearcheItem = {
  id: number;
  type: string;
  name: string;
  searchDt: string;
  thumbnail: string;
  located: string;
  price: number;
  badge: {
    textColor: string;
    backgroundColor: string;
  };
}

export type RecommendServiceItem = {
  id: number;
  uniqueId: string;
  name: string;
  type: string;
  thumbnail: string;
  located: string;
  badge: {
    textColor: string;
    backgroundColor: string;
  }
}

type RecommendLocationItem = {
  id: number;
  name: string;
  totalListing: number;
}

export type GlobalSearchSuggesstionRes = {
  histories: HistoryItem[];
  recentSearches: RecentSearcheItem[];
  recommendServices: RecommendServiceItem[];
  recommendLocations: RecommendLocationItem[];
}

/** *****************************************
 * Global Search Realtime Res Type
 ***************************************** */
export type GlobalRealtimeSearchRes = {
  id: number;
  uniqueId: string;
  name: string;
  type: string;
  thumbnail: string;
  located: string;
  badge: {
    textColor: string;
    backgroundColor: string;
  }
}

/** *****************************************
 * Global Search Res Type
 ***************************************** */
export type GlobalSearchLocationItem = {
  id: number;
  name: string;
  subTitle: string;
  thumbnail: string | null;
}

export type GlobalSearchTypeItems = {
  id: number;
  type: string;
  display: string;
  total: number;
}

export type GlobalSearchDataItems = {
  id: number;
  uniqueId: string;
  name: string;
  type: string;
  thumbnail: string;
  located: string;
  price: number;
  badge: {
    textColor: string;
    backgroundColor: string;
  }
}

export type GlobalSearchRes = {
  location: GlobalSearchLocationItem;
  types: GlobalSearchTypeItems[];
  data: GlobalSearchDataItems[];
}

/** *****************************************
 * Global Trending Search Res Type
 ***************************************** */
export type GlobalTrendingSearchRes = {
  trending: RecentSearcheItem[]
}

/** *****************************************
 * 
 ***************************************** */
export type SearchLogType = "hotel" | "rental" | "spa_msg" | "tour_act" | "taxi" | "location" | "merchant";
export const SEARCH_TYPE_LABELS: Record<SearchLogType | string, string> = {
  hotel: "Hotel",
  rental: "Rental",
  spa_msg: "Spa & Massage",
  tour_act: "Tour & Activity",
  taxi: "Taxi",
  location: "Destination",
  merchant: "Merchant",
};

export const getSearchTypeLabel = (type: string): string => {
  return SEARCH_TYPE_LABELS[type] ?? type.replace(/_/g, " ").toUpperCase();
};